import { useQuery } from '@tanstack/react-query'
import { Navigate } from 'react-router-dom'
import { supabase } from '@/integrations/supabase/client'
import { FullScreenLoader } from '@/components/FullScreenLoader'

export function PortalRouteGuard({ children }: { children: React.ReactNode }) {
  const { data: isJournalist, isLoading, isError } = useQuery({
    queryKey: ['is_journalist'],
    queryFn: async () => {
      const { data: { user }, error: userError } = await supabase.auth.getUser()
      if (userError) throw userError
      if (!user) return false
      const { data, error } = await (supabase
        .from('journalist_profiles')
        .select('id')
        .eq('id', user.id)
        .maybeSingle() as any)
      if (error) throw error
      return !!data
    },
    retry: false,
  })

  if (isLoading) return <FullScreenLoader />

  // See DashboardRouteGuard: a failed request means an invalid session,
  // not a confirmed "not a journalist" — clear it rather than bounce onward.
  if (isError) {
    supabase.auth.signOut()
    return <Navigate to="/auth?mode=signin" replace />
  }

  if (!isJournalist) return <Navigate to="/auth?mode=signin" replace />
  return <>{children}</>
}
